import clsx from "clsx";
import { memo } from "react";
import type { BadgeTone } from "../opportunity.meta";
import "./StatusTabs.scss";

export type StatusTabItem = {
  key: string;
  label: string;
  count: number;
  tone: BadgeTone;
};

type StatusTabsProps = {
  items: StatusTabItem[];
  activeKey: string;
  onChange: (key: string) => void;
};

const formatCount = (count: number) => (count > 99 ? "99+" : String(count));

const StatusTab = memo(
  ({
    item,
    active,
    onChange,
  }: {
    item: StatusTabItem;
    active: boolean;
    onChange: (key: string) => void;
  }) => {
    const handleClick = () => onChange(item.key);

    return (
      <button
        type="button"
        className={clsx("statusTabs__item", active && "isActive")}
        onClick={handleClick}
      >
        <span>{item.label}</span>
        <span className={clsx("statusTabs__badge", `is-${item.tone}`)}>
          {formatCount(item.count)}
        </span>
      </button>
    );
  },
);

StatusTab.displayName = "StatusTab";

export const StatusTabs = memo(({ items, activeKey, onChange }: StatusTabsProps) => {
  return (
    <div className="statusTabs">
      {items.map((item) => (
        <StatusTab key={item.key} item={item} active={item.key === activeKey} onChange={onChange} />
      ))}
    </div>
  );
});

StatusTabs.displayName = "StatusTabs";
